import { View, ViewProps } from 'react-native';

export const GapNone = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: ViewProps['style'];
}) => {
  return <View style={style}>{children}</View>;
};
